import { trpc } from './trpc';
import { inferRouterInputs } from '@trpc/server';
import { AppRouter } from '@tagadapay/trpc-types';
import { useToast } from '@/components/ui/use-toast';

type InputRouter = inferRouterInputs<AppRouter>;

// Input types
export type DemoStoreCreateInput = InputRouter['demo']['createDemoStore'];
export type StoreEraseInput = InputRouter['demo']['eraseStore'];

/**
 * Hook to create a demo store with sample data
 */
export function useCreateDemoStore() {
    const { toast } = useToast();
    const utils = trpc.useUtils();

    return trpc.demo.createDemoStore.useMutation({
        onSuccess: () => {
            utils.stores.list.invalidate();
            toast({
                title: 'Success',
                description: 'Demo store created successfully',
            });
        },
        onError: (error) => {
            toast({
                title: 'Error',
                description: error.message || 'Failed to create demo store',
                variant: 'destructive',
            });
        },
    });
}

/**
 * Hook to erase all data from a store
 */
export function useEraseStore() {
    const { toast } = useToast();
    const utils = trpc.useUtils();

    return trpc.demo.eraseStore.useMutation({
        onSuccess: () => {
            utils.stores.list.invalidate();
            toast({
                title: 'Success',
                description: 'Store erased successfully',
            });
        },
        onError: (error) => {
            toast({
                title: 'Error',
                description: error.message || 'Failed to erase store',
                variant: 'destructive',
            });
        },
    });
}
